import React from 'react';

export default function PayCompletion(){
    return (
        <h2 className="p-5">Your paychange request has been submitted. You may now close this popup window.</h2>
    )
}